


















































import { Component } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { SwTabGroup, SwTabPage, TabProps } from '@sonicwall/unified-ui-framework/src/shared/sw-tab-layout';
import DattoAutotaskPage from './components/autotask/datto-autotask-page.vue';
import ConnectwiseManagePage from './components/connectwise/connectwise-manage-page.vue';
import PSAHubMainTab from './components/psahub/psa-hub-main-tab.vue';

const cssPrefix = 'psa-main-page';
const cwStoreName = 'ConnectWiseManageStoreModule';

@Component({
  components: {
    SwTabGroup,
    SwTabPage,
    DattoAutotaskPage,
    ConnectwiseManagePage,
    PSAHubMainTab,
  },
})
export default class PSAMainPage extends SwExtendedVue {
  cssPrefix = cssPrefix;

  selectedTabId: 'cwmanage' | 'dtautotask' = 'cwmanage';
  selectedMainTabId: 'psahub' | 'cwlegacy' = 'psahub';
  gradientDetails: {};

  get isShowTab() {
    return this.$store.getters['PsaHubStoreModule/isShowTab'] || false;
  }

  mainTabs: TabProps[] = [
    {
      tabId: 'psahub',
      label: this.$t('psaIntegration.psahub')
      .toString(),
    },
  ];
  psaMainTabs: TabProps[] = [
    {
      tabId: 'cwmanage',
      label: this.$t('psaIntegration.cwmanage')
      .toString(),
    },
    {
      tabId: 'dtautotask',
      label: this.$t('psaIntegration.dtautotask')
      .toString(),
    },
  ];

  onChangeTab(tabId: 'cwmanage' | 'cwmanage') {
    this.selectedTabId = tabId;
  }

  onChangeMainTab(tabId: 'psahub' | 'psahub') {
    this.selectedMainTabId = tabId;
  }

  // get showNewComp():boolean {
  //   if (this.$route.query.newux && this.$route.query.newux === 'YES') {
  //     return true;
  //   }
  //   return false;
  // }

  /* tslint:disable-next-line */
  get isAutotaskUser() {
    const roles = JSON.parse(this.$store.getters.getUserInfo).user.roles || [];
    return roles.indexOf('CWAUTOTASK') > -1 ? true : false;
  }

  created() {
    this.$store.commit(`${cwStoreName}/resetState`);
    this.$store.dispatch('PsaHubStoreModule/manageGradient', { mode: 'GET' });
    this.$store.commit('stopLoading');
    // if (this.$route.query.newux && this.$route.query.newux === 'YES') {
    // }
  }

  mounted() {
    const roles = JSON.parse(this.$store.getters.getUserInfo).user.roles || [];
    const isPSA = roles.indexOf('PSA') > -1 ? true : false;
    if (isPSA) {
      this.mainTabs.push({
        tabId: 'cwlegacy',
        label: this.$t('psaIntegration.cwlegacy')
        .toString(),
      });
    }
  }
}
